import '@hotwired/turbo-rails'
import { Application } from '@hotwired/stimulus'
import SelectOtherController from '../../controllers/inquiry_form/select_other_controller'
import FileUploadController from '../../controllers/inquiry_form/file_upload_controller'
import FormSubmitController from '../../controllers/inquiry_form/form_submit_controller'

const application = (window as any).Stimulus || Application.start()
;(window as any).Stimulus = application

application.register('select-other', SelectOtherController)
application.register('file-upload', FileUploadController)
application.register('form-submit', FormSubmitController)
